import React from 'react';
import StandardAppLayout from 'src/shared/components/layout/standard-app-layout/StandardAppLayout';

const UpgradeSubscription = () => {
    const mainContent = (
        <div>
            <h1>Upgrade Subscription</h1>
        </div>
    );

    return <StandardAppLayout mainContent={mainContent} title='Upgrade Subscription' />;
};

export default UpgradeSubscription;
